export enum EAffiliationCommissionHistoryCommissionType {
  DIRECT_REFERRAL = 'DIRECT_REFERRAL',
  SUN_LINE = 'SUN_LINE',
  SAME_RANK = 'SAME_RANK',
}

export enum EAffiliationRankCommission {
  T0 = 0,
  T1 = 1,
  T2 = 2,
  T3 = 3,
  VIP4 = 4,
  VIP5 = 5,
  VIP6 = 6,
}

export const RANK_LABELS: Record<string, string> = {
  T0: '0',
  T1: '1 Star',
  T2: '2 Star',
  T3: '3 Star',
  VIP4: '4 Star',
  VIP5: '5 Star',
  VIP6: '6 Star',
}
